module.exports = __webpack_public_path__ + "img/horizontal_2_1_1.969b61d2.png";